import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";

const createAppStore = async () => {
  try {
    const store = configureStore({ reducer: rootReducer });

    return store;
  } catch (error) {
    throw new Error("Some error occured");
  }
};

export default createAppStore;
